module.exports = "/_next/static/images/smm-image-2x-6afcef3511640628c135e83b2e4ddb69.png.webp";